export const ENVIRONMENTS = {
  PROD: 1,
  STAGE: 2,
  QA: 3,
  LOCAL: 4
} as const

export const JWT_VALIDATION_REGEX = /^[\w-]+\.[\w-]+\.[\w-]+$/;